export default "__VITE_PUBLIC_ASSET__0660f542__"